import { clearLogin, saveLoginIfNeed } from '../../utils/loginSaver/index';

export const actionTypes = {
  REQUEST_START: 'AUTHORIZATION.LOGIN.REQUEST_START',
  SUCCESS: 'AUTHORIZATION.LOGIN.SUCCESS',
  FAILURE: 'AUTHORIZATION.LOGIN.FAILURE',
  START_WORKING: 'AUTHORIZATION.LOGIN.START_WORKING',
  ES_AUTH_CHECK: 'AUTHORIZATION.LOGIN.ES_AUTH_CHECK',
  ES_AUTH_SUCCESS: 'AUTHORIZATION.LOGIN.ES_AUTH_SUCCESS',
  ES_AUTH_FAILURE: 'AUTHORIZATION.LOGIN.ES_AUTH_FAILURE',
  ES_USER_CREATED: 'AUTHORIZATION.LOGIN.USER_CREATED',
  ES_AUTH_WITH_EMAIL: 'AUTHORIZATION.LOGIN.ES_AUTH_WITH_EMAIL',
};

export function startRequest({ data, redirectUrl, username, rememberMe }) {
  saveLoginIfNeed(username, rememberMe);

  return {
    type: actionTypes.REQUEST_START,
    payload: {
      data,
      redirectUrl,
    },
  };
}

export function loginSuccess(tokens) {
  return {
    type: actionTypes.SUCCESS,
    payload: tokens,
  };
}

export function loginFailure(error) {
  clearLogin();

  return {
    type: actionTypes.FAILURE,
    payload: error,
  };
}

export function ESAuthRequestStart({ data, redirectUrl }) {
  return {
    type: actionTypes.ES_AUTH_CHECK,
    payload: {
      data,
      redirectUrl,
    },
  };
}

export function ESAuthSuccess(token) {
  return {
    type: actionTypes.ES_AUTH_SUCCESS,
    payload: token,
  };
}

export function ESAuthFailure(error, errorId) {
  clearLogin();

  return {
    type: actionTypes.ES_AUTH_FAILURE,
    payload: { error, errorId },
  };
}

export function startWorking() {
  return {
    type: actionTypes.START_WORKING,
  };
}

export function userCreated() {
  return {
    type: actionTypes.ES_USER_CREATED,
  };
}

export function ESAuthWithEmail({ data, redirectUrl }) {
  return {
    type: actionTypes.ES_AUTH_WITH_EMAIL,
    payload: {
      data,
      redirectUrl,
    },
  };
}
